<template>
  <a-spin :spinning='confirmLoading'>
    <div>
      <a-button type="primary" @click="handleAddForm" icon="plus">添加</a-button>
    </div>
    <div class='main-box'>
      <div class='be_choose_crf'>
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
            <span slot="sortNumAction" slot-scope="text, record">
              <span v-if="editableId !== record.id" @dblclick="prepareSortChange(record)" style="padding: 0px 10px;">{{text}}</span>
              <span v-else>
                <a-input-number v-model="record.sortNum" style="width: 60px"></a-input-number>
                <a @click="handleSortChange(record)" style="margin: 0px 10px">保存</a>
                <a @click="handleSortCancel">取消</a>
              </span>
            </span>
            <span slot="action" slot-scope="text, record,index">
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
        </a-table>
      </div>
    </div>

     <CsimSchemaPeriodUnSelectFormListModel ref="CsimSchemaPeriodUnSelectFormListModel" @refreshPeriodFormList="refreshPeriodFormList"></CsimSchemaPeriodUnSelectFormListModel>
  </a-spin>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import baseRules from '@/constants/baseRules'
  import { postAction,deleteAction } from '@/api/manage'

  import CsimSchemaPeriodUnSelectFormListModel from './CsimSchemaPeriodUnSelectFormListModel'

  export default {
    name: 'CsimSchemaPeriodFormList',
    mixins:[JeecgListMixin],
    components: {
      CsimSchemaPeriodUnSelectFormListModel,
    },
    props: {
    },
    data() {
      return {
        periodData: {},
        title: '表单选择',
        confirmLoading: false,
        editableId: '',
        rules:{
          name:[baseRules.required],
          sortNum:[baseRules.required],
        },
        disableMixinCreated: true,
        // 表头
        columns: [
          {
            title: '排序',
            dataIndex: 'sortNum',
            align: 'center',
            scopedSlots: { customRender: 'sortNumAction' },
          },
          {
            title: '表单',
            dataIndex: 'formName',
            align: 'center',
            ellipsis: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/scheme/period/form/page/list",
        },
        isorter:{
          column: 'sortNum',
          order: 'asc',
        },
      }
    },
    computed: {
    },
    created() {
    },
    methods: {
      updateFormList(periodData) {
        this.periodData = periodData;

        this.loadForm();
      },
      loadForm(){
        this.baseQueryParam.periodId = this.periodData.id
        if (this.periodData.schemeId && this.periodData.id) {
          this.loadData()
        } else {
          this.dataSource = [];
        }
      },
      refreshPeriodFormList() {
        this.loadForm()
      },
      
      handleDelete(record) {
        deleteAction('/scheme/period/form/delete/' + record.id, {}).then(res => {
          if (res.success) {
            console.log('OK')
          }
          this.loadForm();
        })
      },

      addFormList(){
        this.formListVisible = true
      },

      handleAddForm() {
        this.$refs.CsimSchemaPeriodUnSelectFormListModel.formItemSetHandle(this.periodData);
      },

      handleSetSchemaPeriod(periodData) {
        this.periodData = periodData;

        this.loadForm();
      },

      prepareSortChange(record) {
        console.log("Prepare to edit: ", record)
        this.editableId = record.id
      },

      handleSortChange(record) {
        postAction('/scheme/period/form/save',{
          id: record.id,
          formId: record.formId,
          sortNum: record.sortNum,
          periodId: this.periodData.id,
        }).then(res=>{
          if(res.success){
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.refreshPeriodFormList();
          this.editableId = ''
        })
      },

      handleSortCancel() {
        this.editableId = ''
        this.refreshPeriodFormList();
      }
    }
  }
</script>

<style lang='less' scoped>
  .visit_name_row {
    margin-bottom: 8px;
  }
  .main-box {
    padding: 12px;
  }

  /deep/ .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td  .ant-select-selection {
    border: 0!important;
  }
</style>
